<div class="gemstone">
	<customizer-component-header
		[overrideTranslateName]="'CUSTOMIZER.COMPONENTS.GEMSTONE.NAME' | translate"
		[menu]="menu"
		(updateCollapsedOnComponent)="updateCollapsed($event)"
	>
		@if (sizes.length) {
		<customizer-list
			class="bordered"
			[selectedIndex]="selectedSizeIndex"
			[items]="sizes"
			[name]="'Description'"
			[discontinued]="'Discontinued'"
			[editMode]="state === customizerStateEnum.EDITORDER"
			[variantOrModelIsNew]="variantOrModelIsNew"
			[(scrollPosition)]="menu.menuDetails.scrollPosition"
			[isGemstone]="true"
			[image]="getImage"
			[noneChoiceImage]="noneChoiceImage"
			[noneChoiceTranslation]="noneChoiceTranslation"
			(selectedChange)="onSizeSelect($event)"
		></customizer-list>
		}
	</customizer-component-header>
</div>